<template>
  <v-container fluid>
    <v-row dense>
      <v-col :key="schedule.id" cols="12" lg="6" v-for="schedule in wrappedSchedules">
        <template v-if="schedule.id === CREATE_SCHEDULE_NAME">
          <v-card height="50" class="d-flex justify-center align-center" @click.stop="onSchedule(schedule)">
            <v-icon>mdi-plus</v-icon>
          </v-card>
        </template>
        <template v-else>
          <v-card class="schedule-item d-flex" @click.stop="onSchedule(schedule)">
            <v-card flat
                width="280"
                class="d-flex flex-column justify-center"
                :color="schedule.active ? 'primary' : 'grey-darken-1'">
              <v-card-text class="white--text d-flex flex-column justify-center">
                <div>{{ schedule.name || afterLabel(schedule) || atLabel(schedule) }}</div>
                <div>{{ schedule.nextDate && `${dayjs(schedule.nextDate).format('YYYY-MM-DD HH:mm:ss')} 예정` }}</div>
              </v-card-text>
            </v-card>
            <v-card flat class="d-flex flex-column justify-center flex-1-1">
              <v-card-text class="white--text">
<!--                <div>{{ schedule.activeDate && `${dayjs(schedule.activeDate).format('YYYY-MM-DD HH:mm:ss')} 활성` }}</div>-->
<!--                <div>{{ schedule.lastDate && `${dayjs(schedule.lastDate).format('YYYY-MM-DD HH:mm:ss')} 마지막 실행` }}</div>-->
                <div>{{ contentDeviceText(schedule) }}</div>
                <div>{{ schedule.commands.map(({name}) => name).join(', ') }}</div>
              </v-card-text>
              <span class="schedule-item__close" @click.stop="onScheduleDelete(schedule)"><v-icon color="grey">mdi-close</v-icon></span>
            </v-card>
          </v-card>
        </template>
      </v-col>
    </v-row>
    <v-schedule-dialog
        v-model="dialog.schedule"
        @on-cancel="dialog.schedule.onCancel"
        @on-ok="dialog.schedule.onOk"
        @update:modelValue="dialog.schedule.onUpdate"
        v-if="dialog.schedule.isOpened"
    ></v-schedule-dialog>
  </v-container>
</template>

<script setup>
import {ref, reactive, computed, inject, onMounted, toRaw, onUnmounted} from 'vue';
import VScheduleDialog from '@/components/VScheduleDialog.vue';
import {CREATE_SCHEDULE_NAME} from '@/common/constants';
import {afterLabel, atLabel, contentDeviceText, contentText} from '@/common/utils';
import {useAppStore} from '@/stores/app';
import dayjs from "dayjs";

const axios = inject('axios');
const appStore = useAppStore();

const content = reactive({
  loadScheduleInterval: null,
});

const wrappedSchedules = computed(() => [{
  id: CREATE_SCHEDULE_NAME,
}, ...appStore.schedules]);

const dialog = reactive({
  schedule: {
    isOpened: false,
  }
});

onMounted(() => {
  appStore.loadSchedules();
  content.loadScheduleInterval = setInterval(appStore.loadSchedules, 30 * 1000);
});

onUnmounted(() => {
  content.loadScheduleInterval && clearInterval(content.loadScheduleInterval);
  content.loadScheduleInterval = null;
});

const onSchedule = async schedule => {
  const update = await new Promise(r => dialog.schedule = {
    isOpened: true,
    name: '',
    condition: '',
    active: true,
    devices: [],
    commands: [],
    ...schedule && schedule,
    onCancel: () => r(),
    onOk: r,
  });
  dialog.schedule.isOpened = false;
  if (!update) return;

  if (update.id === CREATE_SCHEDULE_NAME) {
    try {
      const response = await axios.post(`/api/schedule`, {
        ...toRaw(update)
      });
      if (!response || 200 !== response.status || 0 !== response.data.code) return;

      await appStore.loadSchedules();

    } catch (error) {
      console.log(error);
    }
    return;
  }

  try {
    const response = await axios.put(`/api/schedule/${update.id}`, {
      ...toRaw(update)
    });
    if (!response || 200 !== response.status || 0 !== response.data.code) return;

    await appStore.loadSchedules();

  } catch (error) {
    console.log(error);
  }
};

const onScheduleDelete = async schedule => {
  if (!confirm('스케쥴을 삭제하시겠습니까?')) return;

  try {
    const response = await axios.delete(`/api/schedule/${schedule.id}`);
    if (!response || 200 !== response.status || 0 !== response.data.code) return;

    await appStore.loadSchedules();

  } catch (error) {
    console.log(error);
  }
};

</script>

<style scoped>
.schedule-item {
  position: relative;
}
.schedule-item .schedule-item__close {
  position: absolute;
  display: block;
  top: 0;
  right: 0;
  padding: 8px;
}
.schedule-item:hover .schedule-item__close {
  display: block;
}

</style>
